export class ShowFertilizerByIdUseCase {
  constructor(api){
    this.api=api
  }
  async execute(id) {
    const raw = `
      SELECT * FROM CROP.FERTILIZER WHERE ID = ${id};
    `
    const resp= await this.api.sql({
      data:{
        sql:raw
      }
    })

    return resp
  }
}
